'use strict'

const extend = require('extend')
const Logger = require('@gsm/logger')
const Q = require('q')
const Util = require('../common/util')

const SQL = {
    SelectProperties: {
        template: [
            'SELECT `service`.`name` AS `service`,',
            '`activity`.`name` AS `activity`,',
            '`property`.`type`,',
            '`property`.`name` AS `property`,',
            '`property`.`value`',
            'FROM `access_policy_property` AS `property`',
            'INNER JOIN `access_policy_activity` AS `activity`',
            'ON `property`.`activity_id` = `activity`.`id`',
            'INNER JOIN `access_policy_service` AS `service`',
            'ON `activity`.`service_id` = `service`.`id`'
        ].join(' ')
    },
    SelectPolicies: {
        template: [
            'SELECT p.content',
            'FROM access_policy AS p',
            'INNER JOIN access_role AS r',
            'ON p.id = r.policy_id'
        ].join(' ')
    }
}

const getPoliciesForPrincipals = (mysqlHelper) => {
    return function (principals) {
        const sql = [
            SQL.SelectPolicies.template
        ]
        principals.forEach((p, i) => {
            const keyword = 0 === i ? 'WHERE' : 'OR'
            sql.push(`${keyword} r.principal = ?`)
        })
        return mysqlHelper.runQuery(sql.join(' '), principals)
            .then(results => {
                const parsed = []
                results.forEach(r => {
                    try {
                        parsed.push(JSON.parse(r.content))
                    }
                    catch (error) {
                        Logger.warn('Failed parsing policy')
                        Logger.warn(error.stack)
                    }
                })
                return parsed
            })
            .catch(error => {
                Logger.warn(error.stack)
                return []
            })
    }
}

const propertyCache = {}

const loadProperties = (mysqlHelper) => {
    if (Object.keys(propertyCache).length) {
        return Q(extend(true, {}, propertyCache))
    }
    const sql = SQL.SelectProperties.template
    return mysqlHelper.runQuery(sql)
        .then(results => {
            results.forEach(r => {
                if (!propertyCache[r.service]) {
                    propertyCache[r.service] = {}
                }
                if (!propertyCache[r.service][r.activity]) {
                    propertyCache[r.service][r.activity] = {}
                }
                if (!Array.isArray(propertyCache[r.service][r.activity][r.property])) {
                    propertyCache[r.service][r.activity][r.property] = []
                }
                propertyCache[r.service][r.activity][r.property].push({
                    type: r.type,
                    value: r.value
                })
            })
            return extend(true, {}, propertyCache)
        })
        .catch(error => {
            Logger.warn(error.stack)
            Logger.warn(`With SQL: ${sql}`)
            throw new Error('Failed to retrieve properties')
        })
}

const extractPropsFromService = (service, activities, target) => {
    activities.forEach(a => {
        const activity = service[a.activity]
        if (!activity) {
            Logger.debug(`No access_policy_activity matching ${a.activity}`)
            return
        }
        Object.keys(activity).forEach(pName => {
            activity[pName].forEach(p => {
                if (!target[p.type]) {
                    target[p.type] = {}
                }
                if (!target[p.type][pName]) {
                    target[p.type][pName] = {}
                }
                target[p.type][pName][p.value] = true
            })

        })
    })
}

const getProperties = (mysqlHelper) => {
    return function (actions, type) {
        type = undefined === type ? Util.Wildcard : type
        return loadProperties(mysqlHelper)
            .then(services => {
                const byType = {}
                actions.forEach(action => {
                    const service = services[action.service]
                    if (!service) {
                        Logger.debug(`No access_policy_service matching ${action.service}`)
                        return
                    }
                    const activityNames = []
                    if (Util.Wildcard === action.activity) {
                        const wildActions = Object.keys(service).map(activity => {
                            return {
                                service: action.service,
                                activity
                            }
                        })
                        activityNames.push.apply(activityNames, wildActions)
                    }
                    else {
                        activityNames.push(action)
                    }
                    extractPropsFromService(service, activityNames, byType)
                })
                if (Util.Wildcard !== type) {
                    const propertiesByType = Object.keys(byType[type] || {})
                    return propertiesByType.map(pName => {
                        return {
                            name: pName,
                            values: Object.keys(byType[type][pName])
                        }
                    })
                }
                const distinctProps = Object.keys(byType).reduce((m, tName) => {
                    return Object.keys(byType[tName]).reduce((m2, pName) => {
                        m2[pName] = byType[tName][pName]
                        return m2
                    }, m)
                }, {})
                return Object.keys(distinctProps)
                    .map(pName => {
                        return {
                            name: pName,
                            values: Object.keys(distinctProps[pName])
                        }
                    })
            })
            .catch(error => {
                Logger.error(error.stack)
                return []
            })
    }
}

/**
 * Create DB helpers using mysqlHelper for AccessPolicy factory.
 * @param mysqlHelper
 * @returns {{getPoliciesForPrincipals: function({principals}), getProperties: function({activity}, {type})}}
 */
const getHelpers = (mysqlHelper) => {
    return {
        getPoliciesForPrincipals: getPoliciesForPrincipals(mysqlHelper),
        getProperties: getProperties(mysqlHelper)
    }
}

module.exports = {
    getHelpers,
    _testExports: {
        extractPropsFromService,
        getPoliciesForPrincipals,
        getProperties,
        loadProperties,
        propertyCache
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/access-policy/db-helpers.js
// module id = 291
// module chunks = 51